<template>
  <div class="cmp-expandable-lines ut-fc">
    <template v-for="(item, index) in limitedItems">
      <slot name="item" v-bind:item="item" v-bind:index="index">
        <div class="ex_lines--item" :key="item">
          {{ item }}
        </div>
      </slot>
    </template>
    <div
      @click="onExpandableUIClick"
      class="ex_lines-expandable-button ut-fb ut-link"
      v-if="showExpandable && isLimited"
    >
      {{ expandableUIText }}
    </div>
  </div>
</template>


<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    max: {
      type: Number,
      default: 5,
    },
    showExpandable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    limitedItems() {
      return this.expanded ? this.items : this.items.slice(0, this.max);
    },
    minimizedCount() {
      return this.items.length - this.max;
    },
    isLimited() {
      return this.minimizedCount > 0;
    },
    expandableUIText() {
      return this.expanded
        ? `Show Less`
        : `... and ${this.minimizedCount} more`;
    },
  },
  methods: {
    onExpandableUIClick() {
      this.expanded = !this.expanded;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
</style>